export type RequestStatus = 'idle' | 'loading' | 'succeeded' | 'failed';
export type domesticOverseas = 'DOMESTIC' | 'OVERSEAS' | 'DOMESTIC_OVERSEAS';
export interface ErrorResponse {
  message: string;
  status: number;
  data?: unknown;
}

export interface Pageable {
  offset: number;
  pageNumber: number;
  pageSize: number;
  paged: boolean;
}

export interface ContactForm {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  message: string;
}

export interface InquiryForm {
  clientName: string;
  companyWebsite?: string;
  country: string;
  industry: string;
  pocName: string;
  pocEmail: string;
  pocPhone: string;
  numberOfOpenings?: number;
  startDate?: string;
  domesticOverseas?: domesticOverseas;
}

export interface List {
  empty: boolean;
  first: boolean;
  last: boolean;
  pageable: Pageable;
  totalElements: number;
  totalPages: number;
}

export interface Params {
  page?: number | null;
  pageSize: number;
  sortField?: string | null;
  order?: SortOrders | null;
}

export enum SortOrders {
  Asc = 'ascend',
  Desc = 'descend'
}
